export default __webpack_public_path__ + "static/media/vale.1574a766.png";